import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeleteApplicationProductMutation} from '../hooks/useApplicationProductsQuery';
import {useApplicationProductsSelection} from "../hooks/useApplicationProductsSelection.ts";


export const DeleteRecordButton = () => {

    const deleteApplicationProductMutation = useDeleteApplicationProductMutation();

    const {
        selection,
        handleClearSelection,
    } = useApplicationProductsSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deleteApplicationProductMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
